/**
 * JetImob Provider
 * Sistema de gestão imobiliária
 */

import type { DatabaseProvider } from '../types';

export const jetimobProvider: DatabaseProvider = {
  id: 'database-jetimob',
  name: 'JetImob',
  description: 'Sistema de gestão imobiliária',
  type: 'properties',
  color: '#3b82f6', // blue-600
  icon: 'home',
  authFields: [
    {
      name: 'apiToken',
      type: 'text',
      label: 'API Token *',
      placeholder: 'Cole aqui seu token de API do JetImob',
      required: true,
      helpText: 'Você pode encontrar seu token de API nas configurações da sua conta JetImob',
    },
  ],
  isAvailable: true,
};
